export default __webpack_public_path__ + "341cafdf3faa61ef6fa40ce180c243c8.svg";